import React from 'react';
import Login from './Login'
import {setMicrositeColour} from '../helpers/style'

class MicrositeLogin extends Login {

  displaySchoolLogo() {
    if (this.props.params.microsite !== undefined) {
      sessionStorage.setItem('microsite', this.props.params.microsite);
      setMicrositeColour(this.props.params.microsite);
    }

    const logoUrl = `https://msh-assets.s3.ca-central-1.amazonaws.com/prod-microsites/img/logos/${this.props.params.microsite}.png`;

    return <img className='microsite-logo' src={logoUrl} size="lg" />
  }
}

export default MicrositeLogin;



// WEBPACK FOOTER //
// ./src/components/MicrositeLogin.js